import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../context/UserContext";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { it } from "date-fns/locale";
import api from "../Api";

registerLocale("it", it);

export default function CalendarStatsBox({ onDateRangeChange }) {
  const { user } = useContext(UserContext);
  // Calcola il primo e l'ultimo giorno del mese corrente
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  // Imposta come valore predefinito le date del mese corrente
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(lastDayOfMonth);
  const [counts, setCounts] = useState({ pending: 0, open: 0, closed: 0 });

  const fetchActivities = async (start, end) => {
    try {
      let endpoint = "/activity/range";
      let params = {
        start: start.toISOString().split("T")[0],
        end: end.toISOString().split("T")[0],
      };
      if (user && user.role === "rup") {
        endpoint = "/activity/worksite-range";
        params.worksite = user.worksite;
      }
      const res = await api.get(endpoint, { params });
      setCounts(res.data); // es: { pending: 2, open: 5, closed: 1 }
    } catch (err) {
      console.error("Errore nel fetch attività:", err);
      setCounts({ pending: 0, open: 0, closed: 0 });
    }
  };

  // Effettua il fetch delle attività ogni volta che il range cambia
  useEffect(() => {
    if (startDate && endDate) {
      fetchActivities(startDate, endDate);
      if (onDateRangeChange) {
        onDateRangeChange(startDate, endDate);
      }
    }
  }, [startDate, endDate, onDateRangeChange]);

  return (
    <div className="col-span-1 row-span-1 bg-primary rounded-2xl shadow p-6 border-2 border-secondary">
      <h2 className="text-lg font-semibold mb-4 text-white">
        Panoramica attività
      </h2>
      <div className="flex justify-around text-sm text-gray-700 mb-4 bg-primary border-b border-whitesmoke pb-2">
        <div className="flex flex-col items-center text-smokeWhite text-lg">
          <span className="text-pending font-semibold">{counts.pending}</span>
          <small>Da aprire</small>
        </div>
        <div className="flex flex-col items-center text-smokeWhite text-lg">
          <span className="text-open font-semibold">{counts.open}</span>
          <small>In corso</small>
        </div>
        <div className="flex flex-col items-center text-smokeWhite text-lg">
          <span className="text-closed font-semibold">{counts.closed}</span>
          <small>Completate</small>
        </div>
      </div>

      <DatePicker
        inline
        selectsRange
        startDate={startDate}
        endDate={endDate}
        onChange={([start, end]) => {
          setStartDate(start);
          setEndDate(end);
        }}
        dateFormat="dd/MM/yyyy"
        locale="it"
        calendarClassName="bg-primary w-full flex justify-center border-none"
      />
    </div>
  );
}
